const texasform = document.getElementById("texas-form");
const response = texasform.querySelector(".response");

const fieldNames = ["firstName", "lastName", "zip", "email"];

texasform.addEventListener("submit", (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const formProps = Object.fromEntries(formData);
  response.innerHTML = "";

  if (formProps.middleInitial && formProps.middleInitial.length > 0) {
    response.innerHTML = "Entry Submitted!";
    e.submitter.style.display = "none";
    return false;
  }

  let error = false;
  fieldNames.forEach((name) => {
    const elm = document.getElementsByName(name)[0];
    if (!formProps[name]) {
      elm.classList.add("error");
      error = true;
    } else {
      elm.classList.remove("error");
    }
  });

  if (error) {
    response.innerHTML = "Please fill out all fields.";
    return false;
  } else {
    response.innerHTML = "";
  }

  const body = {
    offerSku: "1c-offer-energy-outlet",
    address: {
      zip: formProps.zip,
    },
    email: formProps.email,
    firstName: formProps.firstName,
    lastName: formProps.lastName,
  };

  fetch("https://api.onecountry.com/v2/offers/claim", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((res) =>
      res.json().then(() => {
        response.innerHTML = "Entry Submitted!";
        e.submitter.style.display = "none";
      }),
    )
    .catch((error) => {
      console.error("Error:", error);
      response.innerHTML =
        "An error occurred while submitting. Please try again later.";
    });

  return false;
});
